module.exports = __webpack_public_path__ + "static/media/f_glasses_circular.77685907.png";